import { TypeValidationVas } from '../../interfaces/TypeValidationVas/TypeValidationVas'
import { typeValidationVasActionTypes } from '../types/typeValidationVasActionTypes'

export type TypeValidationVasActions =
  | TypeValidationVasAction
  | TypeValidationVasActionAsync

export interface TypeValidationVasAction {
  type: typeof typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS_EXITO
  typeValidationVas: TypeValidationVas[] | undefined
  error: string | undefined
}

export const getTypeValidationVasAction = (
  typeValidationVas?: TypeValidationVas[],
  error?: string
): TypeValidationVasAction => {
  return {
    type: typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS_EXITO,
    typeValidationVas,
    error
  }
}

// Esto va a SAGA
export interface TypeValidationVasActionAsync {
  type: typeof typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS
}

export const getTypeValidationVasActionAsync =
  (): TypeValidationVasActionAsync => {
    return {
      type: typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS
    }
  }
